import { getConfig } from '../apiConfig';

export const isAbsolute = (url) => {
	return new RegExp('^(?:[a-z]+:)?//', 'i').test(url);
};

export const safeSameOriginUrl = (url) => {
	if (typeof url !== 'string' || url.length === 0) return null;

	if (typeof window === 'undefined') return url;

	try {
		const parsed = new URL(url, window.location.origin);
		if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
		return `${window.location.origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
	} catch {
		return null;
	}
};

export const removeDomain = (str) => {
	if (!str || typeof str !== 'string') {
		return null;
	}
	return str.replace(/(https?:)?\/\/[^/]+/i, '');
};

export const removeQueryString = (str) => {
	if (!str || typeof str !== 'string') {
		return null;
	}

	return str.split('?')[0];
};

export const cleanMalformedQueryString = (str) => {
	// Context: External systems, like SalesForce, sometimes wrongly append analytics query parameters with a "?" instead of a "&".
	// If a "?" is used while the URL already contains a query parameter, it's seen as part of this query parameter.
	return removeQueryString(str);
};

export const host = () => {
	if (__DEBUG__ && __CLIENT__) return `${window.location.protocol}//${window.location.host}`;
	else return getConfig().host;
};
